import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { Icon24 } from '../../../../components/Icon';
import { P1, P2 } from '../../../../components/Typographies/Paragraph';
import { H2 } from '../../../../components/Typographies/Title';
import ImageMobileApp from '../../../../images/illustrations/mobile-app-homepage-mockup.png';
import ImageMobileApp2X from '../../../../images/illustrations/mobile-app-homepage-mockup-2x.png';
import { APP_BULLETS } from './constants';
import { homePageAppMessages } from './messages';

const Container = styled.div`
  ${tw` my-big flex flex-col items-center`}
  gap:var(--size-medium)
`;

const Card = styled.div`
  ${tw`relative w-full bg-primary-400 rounded-30 flex-col items-center `}

  @media (min-width: 992px) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 24px;
    grid-row-gap: 0px;
  }
`;

const Title = styled(H2)`
  ${tw`text-white`}

  .highlight {
    ${tw`text-terciary500`}
  }
`;

const Content = styled.div`
  ${tw`flex flex-col text-white mx-auto w-full flex py-big px-medium2   lg:px-0`}
  gap:var(--size-medium2);
  margin: 0 auto;

  @media (min-width: 992px) {
    grid-area: 1 / 2 / 2 / 8;
  }
`;

const Bullets = styled.div`
  ${tw`md:mx-auto`}
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--size-medium2);

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Bullet = styled.div`
  ${tw`flex items-center`}
  gap:var(--size-small)
`;

const BulletIcon = styled.img`
  ${Icon24}
`;

const DownloadLink = styled.a`
  ${tw`md:hidden`}
`;

const Image = styled.img`
  ${tw`w-full rounded-30 mt-big md:mt-0`}

  @media (min-width: 992px) {
    grid-area: 1 / 8 / 2 / 13;
    align-self: end;
  }
`;

const App = () => (
  <Container>
    <Card>
      <Content>
        <Title>
          <FormattedHTMLMessage {...homePageAppMessages.appTitle} />
        </Title>
        <P1>
          <FormattedHTMLMessage {...homePageAppMessages.appSubtitle} />
        </P1>
        <Bullets>
          {APP_BULLETS.map((bullet, index) => (
            <Bullet key={index}>
              <BulletIcon alt={bullet.altMessage} src={bullet.src} />
              <P2>
                <FormattedMessage {...homePageAppMessages[bullet.message]} />
              </P2>
            </Bullet>
          ))}
        </Bullets>
      </Content>

      <Image
        alt="Image of the tictatrip mobile application"
        sizes="(max-width: 1400px) 100vw, 1400px"
        src={ImageMobileApp}
        srcSet={`${ImageMobileApp2X} 2x`}
      />
    </Card>
    <DownloadLink
      href="https://play.google.com/store/apps/details?id=com.tictactrip.comparateur.bus.train.sncf"
      rel="nofollow"
    >
      <img
        alt="Download the Tictactrip app on Google Play"
        height="58"
        src="/assets/footer/google-play-90h.webp"
      />
    </DownloadLink>

    <DownloadLink
      href="https://apps.apple.com/fr/app/tictactrip-trains-bus-covoit/id1500431872"
      rel="nofollow"
    >
      <img
        alt="Download the Tictactrip app on app store"
        height="58"
        src="/assets/footer/app-store-90h.webp"
      />
    </DownloadLink>
  </Container>
);

export default App;
